import { axios } from '@Root/API'

export const pushToApplicationForm = () => {
	return axios.get('enable-all-programs')
}
